import { ColorStop } from './weatherStations.types';

export const METERS_PER_SEC_TO_MPH_FACTOR = 2.237;

export const EMPTY_DATA_VALUE = '-';

export const TEMPERATURE_COLOR_STOPS: ColorStop[] = [
  { temp: -10, color: '#D9D9D9', contrastTextColor: 'text.primary' },
  { temp: 0, color: '#CA95FF', contrastTextColor: 'text.primary' },
  { temp: 10, color: '#A750FF', contrastTextColor: 'common.white' },
  { temp: 20, color: '#01579B', contrastTextColor: 'common.white' },
  { temp: 30, color: '#6393F2', contrastTextColor: 'text.primary' },
  { temp: 40, color: '#52E8EB', contrastTextColor: 'text.primary' },
  { temp: 50, color: '#4AFB2D', contrastTextColor: 'text.primary' },
  { temp: 60, color: '#509F4E', contrastTextColor: 'common.white' },
  { temp: 70, color: '#FBDA2D', contrastTextColor: 'text.primary' },
  { temp: 80, color: '#FBC02D', contrastTextColor: 'text.primary' },
  { temp: 90, color: '#F19437', contrastTextColor: 'common.white' },
  { temp: 100, color: '#E25345', contrastTextColor: 'common.white' },
  { temp: 110, color: '#FFFFFF', contrastTextColor: 'text.primary' },
];
